import React from 'react';
import { useP } from '../i18n/useP';
import './BfreBars.css';

/**
 * BFRE BARS — le besoin en fonds de roulement par composante (proto Olivier du
 * 2026-10-16) : une barre horizontale par poste, un repère sur sa valeur de
 * début de période, la valeur de fin, et l'IMPACT SUR LA LIQUIDITÉ en francs
 * (signe inverse de la variation du poste : des débiteurs qui montent
 * consomment du cash, des fournisseurs qui montent en libèrent). Un impact
 * négatif se lit en ambre.
 *
 * Props :
 *   rows     : [{ key, label, kind: 'asset' | 'debt' | 'total', end, start }]
 *   fmt      : (francs) => texte
 *   fmtSign  : (francs) => texte signé
 *   endLabel : libellé de la colonne de valeur (« 30.09 »)
 *   startLabel : ce que le repère représente (« 31.12.2025 »)
 */
export default function BfreBars({ rows, fmt, fmtSign, endLabel, startLabel }) {
  const p = useP();
  const known = rows.filter((r) => Number.isFinite(r.end) && Number.isFinite(r.start));
  const max = Math.max(1, ...known.flatMap((r) => [Math.abs(r.end), Math.abs(r.start)])) * 1.1;
  return (
    <div className="lk-bfre">
      <div className="lk-bfre__legend">
        <span><i className="lk-bfre__sw lk-bfre__sw--asset" />{p('créances, stock')}</span>
        <span><i className="lk-bfre__sw lk-bfre__sw--debt" />{p('dettes')}</span>
        <span><i className="lk-bfre__sw lk-bfre__sw--tick" />{startLabel}</span>
      </div>
      <div className="lk-bfre__row lk-bfre__row--head">
        <span>{p('Composante')}</span><span /><span>{endLabel}</span><span>{p('Impact liquidité')}</span>
      </div>
      {rows.map((r) => {
        const ok = Number.isFinite(r.end) && Number.isFinite(r.start);
        const sign = r.kind === 'debt' ? -1 : 1;
        const impact = ok ? -sign * (r.end - r.start) : null;
        return (
          <div key={r.key} className={`lk-bfre__row${r.kind === 'total' ? ' lk-bfre__row--total' : ''}`}>
            <span>{r.label}</span>
            <span className="lk-bfre__bar">
              {ok && <i className={`lk-bfre__fill lk-bfre__fill--${r.kind}`} style={{ width: `${(Math.abs(r.end) / max) * 100}%` }} />}
              {ok && <i className="lk-bfre__tick" style={{ left: `${(Math.abs(r.start) / max) * 100}%` }} />}
            </span>
            <span className="lk-bfre__v">{ok ? fmt(r.end) : '—'}</span>
            <span className={`lk-bfre__d${impact != null && Math.round(impact) < 0 ? ' is-neg' : ''}${impact != null && Math.round(impact) === 0 ? ' is-nil' : ''}`}>
              {impact == null ? '—' : (Math.round(impact) === 0 ? p('stable') : fmtSign(impact))}
            </span>
          </div>
        );
      })}
    </div>
  );
}
